import { Component, OnInit } from '@angular/core';
import { AppMainComponent } from '../main/app.main.component';
import { MenuService } from './app.menu.service';
import { Menus } from './menus';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
    styleUrls: ['./app.menu.component.scss']
})
export class AppMenuComponent implements OnInit {
    menus: Menus[];

    constructor(public app: AppMainComponent, private menuService: MenuService) { }

    ngOnInit() {
        this.menuService.getByRole().subscribe(menus => {
            this.menus = menus;
        });
    }

    onMenuClick() {
        this.app.menuClick = true;
    }
}
